import { render, staticRenderFns } from "./AdminVipGroupTableRow.vue?vue&type=template&id=6ee231cc&"
import script from "./AdminVipGroupTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminVipGroupTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports